import { Routes } from '@angular/router';
import { MainpageComponent } from './layout/mainpage/mainpage.component';
import { authGuard } from './guard/auth.guard';
import { modalNavigationGuard } from './guard/modal-navigation.guard';


export const routes: Routes = [
    {
        path: ':tenantcode/email',
        canActivate: [modalNavigationGuard],
        loadComponent: () => import('./modules/pages/email-mfa/email-mfa.component').then(m => m.EmailMfaComponent)
    },
    {
        path: '',
        canActivate: [modalNavigationGuard],
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: ':tenantcode',
        // path: '',
        component: MainpageComponent,
        canActivate: [modalNavigationGuard, authGuard],
        children: [
            {
                path: '',
                canActivate: [modalNavigationGuard],
                runGuardsAndResolvers: 'always',
                loadChildren: () => import('./modules/pages/pages.module').then(m => m.PagesModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'resource-not-found',
        pathMatch: 'full'
    }
];
